function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#75798A",
  fillRule: "evenodd",
  d: "M10.064 26c12.076 0 18.68-10.002 18.68-18.675 0-.284-.006-.567-.02-.848C30.008 5.55 31.122 4.394 32 3.078c-1.176.522-2.442.875-3.77 1.033 1.355-.812 2.396-2.098 2.887-3.63-1.27.751-2.674 1.298-4.17 1.593C25.75.798 24.045 0 22.157 0c-3.626 0-6.567 2.94-6.567 6.563 0 .515.058 1.016.17 1.497-5.456-.275-10.294-2.886-13.532-6.858-.564.97-.889 2.097-.889 3.299 0 2.277 1.16 4.287 2.922 5.464-1.077-.034-2.089-.33-2.974-.822l-.001.084c0 3.18 2.263 5.833 5.267 6.435-.551.15-1.132.23-1.73.23-.424 0-.835-.041-1.235-.118.836 2.608 3.26 4.506 6.133 4.56-2.247 1.76-5.078 2.809-8.154 2.809-.53 0-1.052-.03-1.566-.091C2.906 24.913 6.356 26 10.064 26"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.8002473c.svg";
export { ForwardRef as ReactComponent };